import React from 'react';
import './PageController.css';

function PageController(props) {
  const {listIndex, numPages, setListIndex} = props;

  const handleClick = ({target}) => {
    const {name} = target;

    if (name === 'plus' && listIndex < numPages) {
      setListIndex(listIndex + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (name === 'minus' && listIndex > 1) {
      setListIndex(listIndex - 1);
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (name === 'begin' && listIndex > 1) {
      setListIndex(1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (name === 'last' && listIndex < numPages) {
      setListIndex(numPages);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (    
    <section className="page-controller-container">
      <button name="begin" onClick={(e) => handleClick(e)}>{'<<'}</button>
      <button name="minus" onClick={(e) => handleClick(e)}>{'<'}</button>
      <p>{`página ${listIndex} de ${numPages}`}</p>
      <button name="plus" onClick={(e) => handleClick(e)}>{'>'}</button>
      <button name="last" onClick={(e) => handleClick(e)}>{'>>'}</button>
    </section >
  )
}

export default PageController